import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0850 = React.lazy(() => import('./symbols/0850_eating_spoon_fork_knife'));
const Symbol0851 = React.lazy(() => import('./symbols/0851_cooking'));
const Symbol0852 = React.lazy(() => import('./symbols/0852_tea_coffee_hot'));
const Symbol0853 = React.lazy(() => import('./symbols/0853_coffee_to_go_starbucks'));
const Symbol0854 = React.lazy(() => import('./symbols/0854_milk_tetra_pak'));
const Symbol0855 = React.lazy(() => import('./symbols/0855_martini_cocktail_drink'));
const Symbol0856 = React.lazy(() => import('./symbols/0856_vine_glass_drink'));
const Symbol0857 = React.lazy(() => import('./symbols/0857_soda_glass_drink'));
const Symbol0858 = React.lazy(() => import('./symbols/0858_soda_glass_drink'));
const Symbol0859 = React.lazy(() => import('./symbols/0859_margarita_cocktail_drink'));
const Symbol0860 = React.lazy(() => import('./symbols/0860_vine_glass_drink'));
const Symbol0861 = React.lazy(() => import('./symbols/0861_vine_glass_drink'));
const Symbol0862 = React.lazy(() => import('./symbols/0862_soda_coke_pepsi_can'));
const Symbol0863 = React.lazy(() => import('./symbols/0863_fruit_ice_desert_glass'));
const Symbol0864 = React.lazy(() => import('./symbols/0864_beer'));
const Symbol0865 = React.lazy(() => import('./symbols/0865_fish_sea'));
const Symbol0866 = React.lazy(() => import('./symbols/0866_sausage_meat'));
const Symbol0867 = React.lazy(() => import('./symbols/0867_cheese'));
const Symbol0868 = React.lazy(() => import('./symbols/0868_chicken_turkey'));
const Symbol0869 = React.lazy(() => import('./symbols/0869_salad_bowl'));
const Symbol0870 = React.lazy(() => import('./symbols/0870_restaurant_menu_offer'));
const Symbol0871 = React.lazy(() => import('./symbols/0871_meal_eating_restaurant_offer'));
const Symbol0872 = React.lazy(() => import('./symbols/0872_cook_chef_restaurant_kitchen'));
const Symbol0873 = React.lazy(() => import('./symbols/0873_apron_cook_chef_kitchen'));
const Symbol0874 = React.lazy(() => import('./symbols/0874_handgloves_hot_kitchen_utensils'));
const Symbol0875 = React.lazy(() => import('./symbols/0875_glass_fork_knife_restaurant_food'));
const Symbol0876 = React.lazy(() => import('./symbols/0876_knife_fork_knife_restaurant_food'));
const Symbol0877 = React.lazy(() => import('./symbols/0877_salt_pepper_spices'));
const Symbol0878 = React.lazy(() => import('./symbols/0878_chineese_thai_food_bowl'));
const Symbol0879 = React.lazy(() => import('./symbols/0879_cooking_pan_heating'));
const Symbol0880 = React.lazy(() => import('./symbols/0880_grater_kitchen_utensils'));
const Symbol0881 = React.lazy(() => import('./symbols/0881_whisk_kitchen_utensils'));
const Symbol0882 = React.lazy(() => import('./symbols/0882_spatula_kitchen_utensils'));
const Symbol0883 = React.lazy(() => import('./symbols/0883_spatula_kitchen_utensils'));
const Symbol0884 = React.lazy(() => import('./symbols/0884_cheese_knife_slicer_kitchen_utensils'));
const Symbol0885 = React.lazy(() => import('./symbols/0885_meat_chopper_kitchen_utensils'));
const Symbol0886 = React.lazy(() => import('./symbols/0886_pizza_knife_slicer_kitchen_utensils'));
const Symbol0887 = React.lazy(() => import('./symbols/0887_knife_kitchen_utensils'));
const Symbol0888 = React.lazy(() => import('./symbols/0888_big_spoon_soup_kitchen_utensils'));
const Symbol0889 = React.lazy(() => import('./symbols/0889_bottle_opener_kitchen_utensils'));
const Symbol0890 = React.lazy(() => import('./symbols/0890_toaster_kitchen_appliances'));
const Symbol0891 = React.lazy(() => import('./symbols/0891_cooking_hob_kitchen_appliances'));
const Symbol0892 = React.lazy(() => import('./symbols/0892_cooking_oven_kitchen_appliances'));
const Symbol0893 = React.lazy(() => import('./symbols/0893_microwave_oven_kitchen_appliances'));
const Symbol0894 = React.lazy(() => import('./symbols/0894_scale_weight_kitchen_appliances'));
const Symbol0895 = React.lazy(() => import('./symbols/0895_egg_timer_cooking_kitchen_utensils'));
const Symbol0896 = React.lazy(() => import('./symbols/0896_measuring_cup_kitchen_utensils'));
const Symbol0897 = React.lazy(() => import('./symbols/0897_no_drinking_forbidden'));
const Symbol0898 = React.lazy(() => import('./symbols/0898_no_food_eating_forbidden'));
const Symbol0899 = React.lazy(() => import('./symbols/0899_no_cereals_grains'));
const Symbol0900 = React.lazy(() => import('./symbols/0900_carrot_vegetable'));
const Symbol0901 = React.lazy(() => import('./symbols/0901_cherry_fruit'));
const Symbol0902 = React.lazy(() => import('./symbols/0902_wine_grapes'));
const Symbol0903 = React.lazy(() => import('./symbols/0903_orange_peach_fruit'));
const Symbol0904 = React.lazy(() => import('./symbols/0904_apple_fruit'));
const Symbol0905 = React.lazy(() => import('./symbols/0905_pear_fruit'));
const Symbol0906 = React.lazy(() => import('./symbols/0906_lemon_lime_fruit'));
const Symbol0907 = React.lazy(() => import('./symbols/0907_orange_lemon_lime_citrus_fruit'));
const Symbol0908 = React.lazy(() => import('./symbols/0908_strawberry_fruit'));
const Symbol0909 = React.lazy(() => import('./symbols/0909_hamburger_fast_food'));
const Symbol0910 = React.lazy(() => import('./symbols/0910_ketchup_fast_food'));
const Symbol0911 = React.lazy(() => import('./symbols/0911_popcorn_cinema'));
const Symbol0912 = React.lazy(() => import('./symbols/0912_hotdog_fast_food'));
const Symbol0913 = React.lazy(() => import('./symbols/0913_pizza_slice'));
const Symbol0914 = React.lazy(() => import('./symbols/0914_cake_birthday_anniversary'));
const Symbol0915 = React.lazy(() => import('./symbols/0915_cake_birthday_anniversary'));
const Symbol0916 = React.lazy(() => import('./symbols/0916_ice_cream_stick'));
const Symbol0917 = React.lazy(() => import('./symbols/0917_ice_cream_corn'));
const Symbol0918 = React.lazy(() => import('./symbols/0918_cupcake_desert_sweets'));
const Symbol0919 = React.lazy(() => import('./symbols/0919_donut_doughnut_cookie_desert_sweets'));
const Symbol0920 = React.lazy(() => import('./symbols/0920_french_croissant_breakfast_sweets'));
const Symbol0921 = React.lazy(() => import('./symbols/0921_marmalade_breakfast'));
const Symbol0922 = React.lazy(() => import('./symbols/0922_honey'));
const Symbol0923 = React.lazy(() => import('./symbols/0923_egg_breakfast'));
const Symbol0924 = React.lazy(() => import('./symbols/0924_coffee_beans_hand_grinder'));
const Symbol0925 = React.lazy(() => import('./symbols/0925_coffee_beans'));
const Symbol0926 = React.lazy(() => import('./symbols/0926_water_boiler'));
const Symbol0927 = React.lazy(() => import('./symbols/0927_grill_charcoal_barbecue_bbq'));
const Symbol0928 = React.lazy(() => import('./symbols/0928_grill_fire_charcoal_barbecue_bbq'));
const Symbol0929 = React.lazy(() => import('./symbols/0929_grill_charcoal_barbecue_bbq'));
const Symbol0930 = React.lazy(() => import('./symbols/0930_grill_sausage_bbq'));
const Symbol0931 = React.lazy(() => import('./symbols/0931_grill_t_bone_steak_bbq'));

export interface IProps {}

const Food: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0850_eating_spoon_fork_knife" symbol={<Symbol0850 />} />
      <LazySymbol id="0851_cooking" symbol={<Symbol0851 />} />
      <LazySymbol id="0852_tea_coffee_hot" symbol={<Symbol0852 />} />
      <LazySymbol id="0853_coffee_to_go_starbucks" symbol={<Symbol0853 />} />
      <LazySymbol id="0854_milk_tetra_pak" symbol={<Symbol0854 />} />
      <LazySymbol id="0855_martini_cocktail_drink" symbol={<Symbol0855 />} />
      <LazySymbol id="0856_vine_glass_drink" symbol={<Symbol0856 />} />
      <LazySymbol id="0857_soda_glass_drink" symbol={<Symbol0857 />} />
      <LazySymbol id="0858_soda_glass_drink" symbol={<Symbol0858 />} />
      <LazySymbol id="0859_margarita_cocktail_drink" symbol={<Symbol0859 />} />
      <LazySymbol id="0860_vine_glass_drink" symbol={<Symbol0860 />} />
      <LazySymbol id="0861_vine_glass_drink" symbol={<Symbol0861 />} />
      <LazySymbol id="0862_soda_coke_pepsi_can" symbol={<Symbol0862 />} />
      <LazySymbol id="0863_fruit_ice_desert_glass" symbol={<Symbol0863 />} />
      <LazySymbol id="0864_beer" symbol={<Symbol0864 />} />
      <LazySymbol id="0865_fish_sea" symbol={<Symbol0865 />} />
      <LazySymbol id="0866_sausage_meat" symbol={<Symbol0866 />} />
      <LazySymbol id="0867_cheese" symbol={<Symbol0867 />} />
      <LazySymbol id="0868_chicken_turkey" symbol={<Symbol0868 />} />
      <LazySymbol id="0869_salad_bowl" symbol={<Symbol0869 />} />
      <LazySymbol id="0870_restaurant_menu_offer" symbol={<Symbol0870 />} />
      <LazySymbol id="0871_meal_eating_restaurant_offer" symbol={<Symbol0871 />} />
      <LazySymbol id="0872_cook_chef_restaurant_kitchen" symbol={<Symbol0872 />} />
      <LazySymbol id="0873_apron_cook_chef_kitchen" symbol={<Symbol0873 />} />
      <LazySymbol id="0874_handgloves_hot_kitchen_utensils" symbol={<Symbol0874 />} />
      <LazySymbol id="0875_glass_fork_knife_restaurant_food" symbol={<Symbol0875 />} />
      <LazySymbol id="0876_knife_fork_knife_restaurant_food" symbol={<Symbol0876 />} />
      <LazySymbol id="0877_salt_pepper_spices" symbol={<Symbol0877 />} />
      <LazySymbol id="0878_chineese_thai_food_bowl" symbol={<Symbol0878 />} />
      <LazySymbol id="0879_cooking_pan_heating" symbol={<Symbol0879 />} />
      <LazySymbol id="0880_grater_kitchen_utensils" symbol={<Symbol0880 />} />
      <LazySymbol id="0881_whisk_kitchen_utensils" symbol={<Symbol0881 />} />
      <LazySymbol id="0882_spatula_kitchen_utensils" symbol={<Symbol0882 />} />
      <LazySymbol id="0883_spatula_kitchen_utensils" symbol={<Symbol0883 />} />
      <LazySymbol id="0884_cheese_knife_slicer_kitchen_utensils" symbol={<Symbol0884 />} />
      <LazySymbol id="0885_meat_chopper_kitchen_utensils" symbol={<Symbol0885 />} />
      <LazySymbol id="0886_pizza_knife_slicer_kitchen_utensils" symbol={<Symbol0886 />} />
      <LazySymbol id="0887_knife_kitchen_utensils" symbol={<Symbol0887 />} />
      <LazySymbol id="0888_big_spoon_soup_kitchen_utensils" symbol={<Symbol0888 />} />
      <LazySymbol id="0889_bottle_opener_kitchen_utensils" symbol={<Symbol0889 />} />
      <LazySymbol id="0890_toaster_kitchen_appliances" symbol={<Symbol0890 />} />
      <LazySymbol id="0891_cooking_hob_kitchen_appliances" symbol={<Symbol0891 />} />
      <LazySymbol id="0892_cooking_oven_kitchen_appliances" symbol={<Symbol0892 />} />
      <LazySymbol id="0893_microwave_oven_kitchen_appliances" symbol={<Symbol0893 />} />
      <LazySymbol id="0894_scale_weight_kitchen_appliances" symbol={<Symbol0894 />} />
      <LazySymbol id="0895_egg_timer_cooking_kitchen_utensils" symbol={<Symbol0895 />} />
      <LazySymbol id="0896_measuring_cup_kitchen_utensils" symbol={<Symbol0896 />} />
      <LazySymbol id="0897_no_drinking_forbidden" symbol={<Symbol0897 />} />
      <LazySymbol id="0898_no_food_eating_forbidden" symbol={<Symbol0898 />} />
      <LazySymbol id="0899_no_cereals_grains" symbol={<Symbol0899 />} />
      <LazySymbol id="0900_carrot_vegetable" symbol={<Symbol0900 />} />
      <LazySymbol id="0901_cherry_fruit" symbol={<Symbol0901 />} />
      <LazySymbol id="0902_wine_grapes" symbol={<Symbol0902 />} />
      <LazySymbol id="0903_orange_peach_fruit" symbol={<Symbol0903 />} />
      <LazySymbol id="0904_apple_fruit" symbol={<Symbol0904 />} />
      <LazySymbol id="0905_pear_fruit" symbol={<Symbol0905 />} />
      <LazySymbol id="0906_lemon_lime_fruit" symbol={<Symbol0906 />} />
      <LazySymbol id="0907_orange_lemon_lime_citrus_fruit" symbol={<Symbol0907 />} />
      <LazySymbol id="0908_strawberry_fruit" symbol={<Symbol0908 />} />
      <LazySymbol id="0909_hamburger_fast_food" symbol={<Symbol0909 />} />
      <LazySymbol id="0910_ketchup_fast_food" symbol={<Symbol0910 />} />
      <LazySymbol id="0911_popcorn_cinema" symbol={<Symbol0911 />} />
      <LazySymbol id="0912_hotdog_fast_food" symbol={<Symbol0912 />} />
      <LazySymbol id="0913_pizza_slice" symbol={<Symbol0913 />} />
      <LazySymbol id="0914_cake_birthday_anniversary" symbol={<Symbol0914 />} />
      <LazySymbol id="0915_cake_birthday_anniversary" symbol={<Symbol0915 />} />
      <LazySymbol id="0916_ice_cream_stick" symbol={<Symbol0916 />} />
      <LazySymbol id="0917_ice_cream_corn" symbol={<Symbol0917 />} />
      <LazySymbol id="0918_cupcake_desert_sweets" symbol={<Symbol0918 />} />
      <LazySymbol id="0919_donut_doughnut_cookie_desert_sweets" symbol={<Symbol0919 />} />
      <LazySymbol id="0920_french_croissant_breakfast_sweets" symbol={<Symbol0920 />} />
      <LazySymbol id="0921_marmalade_breakfast" symbol={<Symbol0921 />} />
      <LazySymbol id="0922_honey" symbol={<Symbol0922 />} />
      <LazySymbol id="0923_egg_breakfast" symbol={<Symbol0923 />} />
      <LazySymbol id="0924_coffee_beans_hand_grinder" symbol={<Symbol0924 />} />
      <LazySymbol id="0925_coffee_beans" symbol={<Symbol0925 />} />
      <LazySymbol id="0926_water_boiler" symbol={<Symbol0926 />} />
      <LazySymbol id="0927_grill_charcoal_barbecue_bbq" symbol={<Symbol0927 />} />
      <LazySymbol id="0928_grill_fire_charcoal_barbecue_bbq" symbol={<Symbol0928 />} />
      <LazySymbol id="0929_grill_charcoal_barbecue_bbq" symbol={<Symbol0929 />} />
      <LazySymbol id="0930_grill_sausage_bbq" symbol={<Symbol0930 />} />
      <LazySymbol id="0931_grill_t_bone_steak_bbq" symbol={<Symbol0931 />} />
    </>
  );
});

Food.displayName = 'Food';

export default Food;
